import cytoscape from 'cytoscape'
import dagre from 'cytoscape-dagre'

// NOTE: unfortunately, the types for cytoscape-dagre use their own version of
// cytoscape, which causes type issues here
cytoscape.use(dagre as unknown as cytoscape.Ext)

export const LAYOUT_OPTIONS = {
  animate: true,
  animationDuration: 500,
  name: 'dagre',
  padding: 50,
  rankDir: 'TB',
  ranker: 'longest-path',
  spacingFactor: 1.2,
} satisfies dagre.DagreLayoutOptions as cytoscape.LayoutOptions
